export const GetDreamRowFontSize = (difficulty: number) => {
	const largestFontSize = 14;
	const lowestDifficulty = 5;
	const reducePerDifficulty = 0.25;
	const reduceBy = (difficulty - lowestDifficulty) * reducePerDifficulty;
	const fontSize = largestFontSize - Math.ceil(reduceBy);
	return fontSize;
};
